import { config } from './domainConfig';
export const fixedFooterSubdomains = [];
export const ambFooterSubdomains = ['portal', 'max'];
// const onlyFooterSubdomains =['demo'];

export const _isAMBFooterSubdomain = ambFooterSubdomains.indexOf(config.subdomain) >= 0;
export const _isFixedFooterSubdomain = _isAMBFooterSubdomain && fixedFooterSubdomains.indexOf(config.subdomain) >= 0;
